import request from '@/utils/request'

export function findProfileInventories(params) {
  return request({
    url: `/profile_inventories`,
    method: 'get',
    params
  })
}

export function findProfileInventoryImportRecords(params) {
  return request({
    url: `/profile_inventories/import_records`,
    method: 'get',
    params
  })
}

export function importProfileInventories(data) {
  return request({
    url: `/profile_inventories/import`,
    method: 'post',
    data
  })
}

export function reImportProfileInventories(data) {
  return request({
    url: `/profile_inventories/re_import`,
    method: 'post',
    data
  })
}

export function exportProfileInventories(data) {
  return request({
    url: `/profile_inventories/export`,
    method: 'post',
    data
  })
}

export function destroyProfileInventories(data) {
  return request({
    url: `/batch_operations/profile_inventories`,
    method: 'delete',
    data
  })
}
